module.exports = __webpack_public_path__ + "img/logo-netgear.99416f6c.svg";